import React from 'react'
import Invoice_header from '../Header/Invoice_header'
import "../../styles/scope.css";
import { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify"
import DatePicker from "../DatePicker"
import ReactPaginate from "react-paginate";
import { useNavigate } from 'react-router-dom';
import "../../styles/invoice_addnew.css";
import excel_icon from "../../assets/svg/excel_icon.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import download_icon from "../../assets/svg/download_icon.svg";
import axios from 'axios';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import axiosInstance from '../../axiosInstance';
import download_arrow from "../../assets/svg/download_arrow.svg";
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';



const Invoice = () => {
    // let ModuleId = 10
    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);


    const [tableData, setTableData] = useState([]);
    const [error, setError] = useState(null);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const popupRef = useRef(null);
    const [editData, setEditData] = useState(null);
    const [activeTab, setActiveTab] = useState("all");
    const [showSapButton, setShowSapButton] = useState(false);
    const [showBulkSubmitButton, setShowBulkSubmitButton] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState({
        UPLOAD: [],
        SI: [],
    });
    const [loading, setLoading] = useState(false);
    const [sortBy, setSortBy] = useState("dateCreated");
    const [statusCounts, setStatusCounts] = useState({
        all: 0,
        approved: 0,
        rejected: 0,
        completed: 0,
        submitted: 0,
        draft: 0,
        sapPushed: 0,
        final: 0
    });

    const calculateStatusCounts = (total) => {
        return {
            all: total,
            approved: total,
            rejected: total,
            completed: total,
            submitted: total,
            draft: total,
            sapPushed: total,
            final: total
        };
    };

    useEffect(() => {
        if (tableData.length > 0) {
            setStatusCounts(calculateStatusCounts(total));
        }
        console.log("totalcount", total);
    }, [tableData]);

    const handleSapPush = async () => {
        try {
            console.log('Sending SAP trigger request with invoice IDs:', selectedRows);

            const response = await axiosInstance.post('/sap_trigger', {
                invoice_ids: selectedRows
            });

            console.log('SAP trigger response:', response);

            if (response.status === 200) {
                alert("SAP push successful!");
                setSelectedRows([]);
                setShowSapButton(false);
                // Consider refreshing the data after successful push
                fetchData();
            } else {
                alert(`SAP push failed! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("SAP push error:", {
                message: error.message,
                response: error.response,
                stack: error.stack
            });

            let errorMessage = "Something went wrong with SAP push!";
            if (error.response) {
                errorMessage += `\nStatus: ${error.response.status}`;
                if (error.response.data) {
                    errorMessage += `\nError: ${JSON.stringify(error.response.data)}`;
                }
            }
            alert(errorMessage);
        }
    };


    const handleBulkSubmit = async () => {

        console.log('handlesubmit request with invoice IDs:', selectedRows);

        const confirmSubmit = window.confirm(`Are you sure you want to submit ${selectedRows.length} selected invoices?`);
        if (!confirmSubmit) return;

        try {
            // Correct API call for bulk submit
            const response = await axiosInstance.post('/invoice/draft_bulkSubmit', {
                invoice_ids: selectedRows
            });

            console.log('Invoice Draft Bulk Submit response:', response);

            if (response.data.success) {
                toast.success(`${selectedRows.length} invoices submitted successfully!`);

                setSelectedRows([]);
                setShowBulkSubmitButton(false);

                const payload = {
                    skip: 0,
                    limit: limit,
                    filter: {
                        status: "draft",
                    },
                };
                fetchData(payload);
            } else {
                toast.error(response.data.message || "Failed to submit invoices");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to submit invoices");
            console.error("Bulk submit error:", error);
        }
    };


    // useEffect(() => {
    //     const payload = {
    //         // Example payload data; adjust as required by your API
    //         skip: 0,
    //         limit: 5
    //     };
    //     console.log("fetch api called");
    //     fetchData(payload);
    // }, []);


    useEffect(() => {
        const status = activeTab.toLowerCase();

        const payload = {
            skip: 0,
            limit: limit,
            filter: {
                status: status,
            },
        };

        setCurrentPage(0);
        setSkip(0);
        fetchData(payload);
    }, [activeTab]);



    const fetchData = async (payload) => {
        try {

            const requestPayload = payload || {
                skip: skip,
                limit: limit,
                sortBy: sortBy,
                filter: {
                    status: activeTab.toLowerCase()
                }
            };

            // const response = await axios.post(
            //     'https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/invoice_list',
            //     requestPayload,
            // );

            const response = await axiosInstance.post(
                '/invoice/invoice_list',
                requestPayload,
            );

            console.log("invoice list response", response);

            if (response.data && Array.isArray(response.data.job)) {
                setTableData(response.data.job);
                const newTotal = response.data.totalCount || 0;
                setTotal(newTotal);
                setTotalPages(Math.ceil(newTotal / limit));
            } else {
                setTableData([]);
                setTotal(0);
                setTotalPages(0);
            }
        } catch (error) {
            setError(error.message);
            console.error("There was a problem with the API request:", error);
        } finally {
            setLoading(false);
        }
    };



    // Rest of your useEffect hooks remain the same
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closePopup();
            }
        };
        if (isPopupOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isPopupOpen]);

    const handlePageClick = ({ selected }) => {
        const newSkip = selected * limit;
        setCurrentPage(selected);
        setSkip(newSkip);

        const status = activeTab.toLowerCase();

        const payload = {
            limit: limit,
            skip: newSkip,
            filter: {
                status: status,
            },
        };
        fetchData(payload);
    };


    const handleFileUpload = (event, type, rowIndex) => {
        const files = event.target.files;

        if (files.length > 0) {
            setUploadedFiles(prevFiles => ({
                ...prevFiles,
                [rowIndex]: {
                    ...prevFiles[rowIndex],
                    [type]: [...(prevFiles[rowIndex]?.[type] || []), ...files]
                }
            }));
        }
    };

    const removeFile = (rowIndex, type) => {
        setUploadedFiles(prevFiles => {
            const updatedFiles = { ...prevFiles };
            if (updatedFiles[rowIndex]?.[type]) {
                delete updatedFiles[rowIndex][type]; // Remove file entry
            }
            return updatedFiles;
        });
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(0);
        setSkip(0);

        const status = activeTab.toLowerCase();

        const payload = {
            limit: newLimit,
            skip: 0,
            filter: {
                status: status,
            },
        };
        fetchData(payload);
    };


    const handleDateSelection = (date) => {
        console.log("Selected Date:", date);
    };

    const navigate = useNavigate();

    const handleAddNewClick = () => {
        navigate("/invoice_addNew");
    };

    const closePopup = () => {
        setEditData(null);
        setIsPopupOpen(false);
    };

    const isAllSelected = selectedRows.length === tableData.length;
    const isAnySelected = selectedRows.length > 0;

    const handleSelectAll = () => {
        const newSelected = isAllSelected ? [] : tableData.map((row) => row.id);
        setSelectedRows(newSelected);
        // Show SAP button only if all selected are completed
        setShowSapButton(newSelected.length > 0 && tableData.every(row =>
            newSelected.includes(row.id) && row.approval_status.toLowerCase() === "completed"
        ));

        setShowBulkSubmitButton(newSelected.length > 0 && tableData.every(row =>
            newSelected.includes(row.id) && row.approval_status.toLowerCase() === "draft"
        ));
    };

    const handleRowSelect = (id) => {
        const newSelected = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];

        setSelectedRows(newSelected);

        // Get all selected invoices
        const selectedInvoices = tableData.filter(row => newSelected.includes(row.id));

        // Show SAP button only if at least one selected is completed
        // and none are in invalid states
        const hasCompleted = selectedInvoices.some(inv =>
            inv.approval_status.toLowerCase() === "completed"
        );

        const hasInvalid = selectedInvoices.some(inv =>
            !["completed"].includes(inv.approval_status.toLowerCase())
        );

        setShowSapButton(newSelected.length > 0 && hasCompleted && !hasInvalid);



        // Show Bulk Submit button only if at least one selected is draft
        // and none are in invalid states
        const hasDraft = selectedInvoices.some(inv =>
            inv.approval_status.toLowerCase() === "draft"
        );

        const hasDraftInvalid = selectedInvoices.some(inv =>
            !["draft"].includes(inv.approval_status.toLowerCase())
        );

        setShowBulkSubmitButton(newSelected.length > 0 && hasDraft && !hasDraftInvalid);
    };

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
        if (!confirmDelete) return;

        try {
            // const response = await axios.delete(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/delete/${id}`
            // );

            const response = await axiosInstance.delete(
                `/invoice/delete/${id}`
            );

            if (response.status === 200) {
                alert("Invoice deleted successfully!");
                setTableData((prevData) => prevData.filter((row) => row.id !== id));
                setTotal((prevTotal) => prevTotal - 1);
                fetchData();
            } else {
                alert(`Failed to delete the invoice! ${response.statusText}`);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong while deleting!");
        }
    };

    // Filter invoices based on active tab
    const filteredInvoices = tableData.filter(inv => {
        if (activeTab === "all") return true;
        if (activeTab === "approved") return inv.approval_status === "Approved" || "approved";
        if (activeTab === "completed") return inv.approval_status === "Completed" || "completed";
        if (activeTab === "sap pushed") return inv.approval_status === "sap pushed";
        if (activeTab === "final invoice") return inv.approval_status === "final invoice";
        if (activeTab === "submitted") return inv.approval_status === "submitted";
        if (activeTab === "rejected") return inv.approval_status === "rejected";
        if (activeTab === "draft") return inv.approval_status === "draft";
        return true;
    });

    const createClickHandler = (invoice) => {
        return () => {
            const status = invoice.approval_status.toLowerCase();
            if (status === "submitted" || status === "draft" || status === "rejected") {
                navigate("/invoiceEdit", { state: { invoice } });
            }
        };
    };

    return (
        <>
            <Invoice_header />
            <div className="container">
                <div className="invoice-header">
                    <div className="invoice-left-header">

                        <button
                            className={`invoice-btn invoice-all-btn ${activeTab === "all" ? "active" : ""}`}
                            onClick={() => setActiveTab("all")}
                        >
                            All{activeTab === "all" && `(${statusCounts.all})`}
                        </button>


                        <button
                            className={`invoice-btn invoice-draft-btn ${activeTab === "draft" ? "active" : ""}`}
                            onClick={() => setActiveTab("draft")}
                        >
                            Draft{activeTab === "draft" && `(${statusCounts.draft})`}
                        </button>


                        <button
                            className={`invoice-btn invoice-submitted-btn ${activeTab === "submitted" ? "active" : ""}`}
                            onClick={() => setActiveTab("submitted")}
                        >
                            Submitted{activeTab === "submitted" && `(${statusCounts.submitted})`}
                        </button>


                        <AdditionalPermissionWrapper permissionKey="approved" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-approved-btn ${activeTab === "approved" ? "active" : ""}`}
                                onClick={() => setActiveTab("approved")}
                            >
                                Approved{activeTab === "approved" && `(${statusCounts.approved})`}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="rejected" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-rejected-btn ${activeTab === "rejected" ? "active" : ""}`}
                                onClick={() => setActiveTab("rejected")}
                            >
                                Rejected{activeTab === "rejected" && `(${statusCounts.rejected})`}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="completed" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-completed-btn ${activeTab === "completed" ? "active" : ""}`}
                                onClick={() => setActiveTab("completed")}
                            >
                                Completed{activeTab === "completed" && `(${statusCounts.completed})`}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="sap_push" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-completed-btn ${activeTab === "sap pushed" ? "active" : ""}`}
                                onClick={() => setActiveTab("sap pushed")}
                            >
                                SAP Pushed{activeTab === "sap pushed" && `(${statusCounts.sapPushed})`}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="final_inv" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-final-btn ${activeTab === "final invoice" ? "active" : ""}`}
                                onClick={() => setActiveTab("final invoice")}
                            >
                                Final Invoice{activeTab === "final invoice" && `(${statusCounts.final})`}
                            </button>
                        </AdditionalPermissionWrapper>

                    </div>
                    <div className="right-header">
                        {showSapButton && (
                            <button
                                className="sap-push-btn"
                                onClick={handleSapPush}
                                style={{
                                    backgroundColor: '#008B1F',
                                    color: 'white',
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    height: '36px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                SAP Push
                            </button>
                        )}

                        {showBulkSubmitButton && (
                            <button
                                className="sap-push-btn"
                                onClick={handleBulkSubmit}
                                style={{
                                    backgroundColor: '#008B1F',
                                    color: 'white',
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    height: '36px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                Bulk Submit
                            </button>
                        )}

                        {/* {!isAnySelected && (
                        <>
                            <DatePicker onDateChange={handleDateSelection} />
                            <h4>Sort by :</h4>
                            <div className="dropdown">
                                <select id="options" className="dropdown-select">
                                    <option value="option1">Date Created</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </div>
                        </>
                    )} */}
                    </div>
                </div>

                {/* Simplified Filter Component */}
                {/* <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    padding: '15px',
                    border: '1px solid #E5E5E5',
                    borderRadius: '12px',
                    margin: "15px"
                }}>
                    <div>
                        <p className='invoice-filter-header'>Filter</p>
                    </div>
                    <div className='invoice-filter-grid-container'>
                        <div className="invoice-filter-field">
                            <p className="invoice-filter-text">Project</p>
                            <select className="invoice-filter-dropdown">
                                <option value="">Select</option>
                                <option value="Project1">Project 1</option>
                                <option value="Project2">Project 2</option>
                                <option value="Project3">Project 3</option>
                            </select>
                        </div>
                        <div className="invoice-filter-field">
                            <p className="invoice-filter-text">Amount</p>
                            <select className="invoice-filter-dropdown">
                                <option value="">Select</option>
                                <option value="0-10000">$0 - $10,000</option>
                                <option value="10000-50000">$10,000 - $50,000</option>
                                <option value="50000+">$50,000+</option>
                            </select>
                        </div>
                        <div className="invoice-filter-buttons">
                            <button className='invoice-cancel-btn'>Cancel</button>
                            <button className='invoice-apply-btn'>Apply</button>
                        </div>
                    </div>
                </div> */}

                {/* {loading ? (
                    <div className="loading-indicator">Loading...</div>
                ) : error ? (
                    <div className="error-message">Error: {error}</div>
                ) : ( */}

                <div className='invoice-table' style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: "1px" }}>
                                    <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th>Invoice No</th>
                                <th>Project</th>
                                {/* {activeTab === "final invoice" && <th>SAP Doc No.</th>} */}
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Total</th>

                                <th>Current status</th>
                                <th>Next status</th>

                                <th></th>
                                {activeTab == "completed" && (
                                    <th></th>
                                )}

                                {activeTab == "final invoice" && (
                                    <th></th>
                                )}


                            </tr>
                        </thead>
                        <tbody>
                            {filteredInvoices.map((invoice, index) => {
                                // Determine if the row should be clickable (Draft status)
                                const status = invoice.approval_status.toLowerCase();
                                const isDraft = status === "draft" || status === "rejected";
                                const isViewable = ["submitted", "approved", "rejected", "re-submitted", "completed", "sap pushed", "final invoice"].includes(status); // ✅ updated
                                const rowClass = isViewable ? "clickable-row" : "";
                                const rowStyle = isViewable ? { cursor: "pointer" } : { cursor: "default" };

                                const handleRowClick = (e) => {
                                    // Ignore clicks that come from checkboxes or their labels
                                    if (e.target.tagName === 'INPUT' && e.target.type === 'checkbox') {
                                        return;
                                    }

                                    if (isViewable) {
                                        navigate("/invoiceEdit", { state: { invoice } });
                                    }
                                };

                                return (
                                    <tr key={index} className={rowClass} style={rowStyle} onClick={handleRowClick}>
                                        <td onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.includes(invoice.id)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleRowSelect(invoice.id);
                                                }}
                                                onClick={(e) => e.stopPropagation()} // Add this
                                            />
                                        </td>
                                        <td>{invoice.inv_number}</td>
                                        <td>{invoice.project}</td>
                                        {/* {activeTab === "final invoice" && <td>{invoice.sap_doc_no}</td>} */}
                                        <td>{invoice.inv_quantity}</td>
                                        <td>{invoice.inv_rate}</td>
                                        <td>{invoice.inv_amount}</td>

                                        <td>
                                            <button className={`invoice-status-button ${status}`}>
                                                {invoice.approval_status}
                                            </button>
                                        </td>
                                        <td>{invoice.next_status}</td>

                                        {activeTab == "completed" && (
                                            <td>
                                                <div className='invoice-csv-file-downloads'
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px",
                                                        padding: "6px 12px",
                                                        borderRadius: "9999px", // Full pill shape
                                                        border: "1px solid #ccc",
                                                        cursor: "pointer",
                                                        fontWeight: "500",
                                                        width: "fit-content",
                                                        userSelect: "none"
                                                    }}
                                                    onClick={async (e) => {
                                                        e.stopPropagation();
                                                        try {
                                                            const response = await axiosInstance.post(`/sap_csv_generate/${invoice.id}`);
                                                            console.log("response", response);
                                                            const fileUrl = response?.data?.file_url;

                                                            if (fileUrl) {
                                                                // This avoids CORS issues — triggers a direct browser download
                                                                const link = document.createElement('a');
                                                                link.href = fileUrl;
                                                                link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                document.body.appendChild(link);
                                                                link.click();
                                                                document.body.removeChild(link);
                                                            } else {
                                                                alert("File URL not found.");
                                                            }
                                                        } catch (error) {
                                                            console.error("Download failed:", error);
                                                            alert("Failed to download invoice file.");
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={download_arrow}
                                                        alt="Download"
                                                        className="downloads_icon"
                                                        style={{ width: "16px", height: "16px" }}
                                                    />
                                                    <span>CSV</span>
                                                </div>
                                            </td>
                                        )}

                                        {activeTab == "final invoice" && (
                                            <>
                                                <td>
                                                    <div className='invoice-csv-file-downloads'
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            padding: "6px 12px",

                                                            borderRadius: "9999px",
                                                            border: "1px solid #ccc",
                                                            cursor: "pointer",
                                                            fontWeight: "500",
                                                            width: "fit-content",

                                                        }}
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            try {
                                                                const response = await axiosInstance.post(`/sap_csv_generate/${invoice.id}`);
                                                                const fileUrl = response?.data?.file_url;

                                                                if (fileUrl) {
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    alert("File URL not found.");
                                                                }
                                                            } catch (error) {
                                                                console.error("Download failed:", error);
                                                                alert("Failed to download invoice file.");
                                                            }
                                                        }}
                                                    >
                                                        <img
                                                            src={download_arrow}
                                                            alt="Download"
                                                            className="downloads_icon"
                                                            style={{ width: "16px", height: "16px" }}
                                                        />
                                                        <span>CSV</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className='invoice-inv-file-downloads'
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            padding: "6px 12px",
                                                            borderRadius: "9999px", // Full pill shape
                                                            border: "1px solid #ccc",
                                                            cursor: "pointer",
                                                            fontWeight: "500",
                                                            width: "fit-content",
                                                            userSelect: "none"
                                                        }}
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            try {
                                                                const response = await axiosInstance.post(`/final_invoice_file/${invoice.id}`);
                                                                console.log("final invoice response", response);
                                                                const fileUrl = response?.data?.file_url;

                                                                if (fileUrl) {
                                                                    // This avoids CORS issues — triggers a direct browser download
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                    const fileExtension = fileUrl.split('.').pop().toLowerCase();
                                                                    link.setAttribute('download', `invoice_${invoice.id}.${fileExtension}`);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    alert("File URL not found.");
                                                                }
                                                            } catch (error) {
                                                                console.error("Download failed:", error);
                                                                alert("Failed to download invoice file.");
                                                            }
                                                        }}>
                                                        <img
                                                            src={download_arrow}
                                                            alt="Download"
                                                            className="downloads_icon"
                                                            style={{ width: "16px", height: "16px" }}
                                                        />
                                                        <span>INV</span>
                                                    </div>
                                                </td>

                                            </>
                                        )}

                                        <td>
                                            {isDraft && (
                                                <div className="actions" onClick={(e) => e.stopPropagation()}>

                                                    <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                                                        <span className="edit-icon" style={{ cursor: "pointer" }}>
                                                            <img
                                                                src={Vector}
                                                                onClick={createClickHandler(invoice)}
                                                                alt="Edit Icon"
                                                                width="20"
                                                                height="20"
                                                            />
                                                        </span>
                                                    </PermissionWrapper>


                                                    <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                                                        <span className="delete-icon">
                                                            <img src={Delete} alt="Delete Icon" width="40" height="40" onClick={() => handleDelete(invoice.id)} />
                                                        </span>
                                                    </PermissionWrapper>
                                                </div>

                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>


                    </table>
                </div>

                {/* Pagination Controls */}
                <div className="invoice-pagination-container d-flex align-items-center justify-content-between mt-3">
                    <div className="Limit-Dropdown">
                        <label htmlFor="limit" className="fw-semibold">Items per page:</label>
                        <select
                            id="limit"
                            value={limit}
                            onChange={handleLimitChange}
                            className="invoice-form-select d-inline w-auto"
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                        </select>
                    </div>

                    <div className="invoice-react-page d-flex align-items-center gap-4">
                        <ReactPaginate
                            previousLabel="Previous"
                            nextLabel="Next"
                            pageCount={totalPages}
                            onPageChange={handlePageClick}
                            forcePage={currentPage}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            activeClassName="active"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={3}
                            disabledClassName="disabled"
                        />
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
        </>
    )
}

export default Invoice;